export default __webpack_public_path__ + "static/media/mail.3ec3948b.svg";